import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "p-d-flex p-ai-center p-m-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search kn-cursor-pointer" }, null, -1)
const _hoisted_3 = { class: "p-m-4" }
const _hoisted_4 = { class: "p-text-bold" }
const _hoisted_5 = { class: "p-text-bold kn-truncated" }
const _hoisted_6 = { class: "p-d-flex p-flex-row p-ml-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "qbe-join-definition-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.QBEJoinDefinitionDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('qbe.joinDefinitions.dialogTitle')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_InputText, {
            class: "kn-material-input p-ml-2",
            modelValue: _ctx.searchWord,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchWord = $event)),
            placeholder: _ctx.$t('common.search'),
            onInput: _ctx.searchItems
          }, null, 8, ["modelValue", "placeholder", "onInput"])
        ]),
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredRelations, (relation, index) => {
            return (_openBlock(), _createBlock("div", {
              key: relation.id,
              class: "p-d-flex p-flex-row p-ai-center p-m-3"
            }, [
              _createVNode("label", _hoisted_4, _toDisplayString(index + 1), 1),
              _createVNode(_component_Dropdown, {
                class: "kn-material-input p-mx-4",
                modelValue: relation.joinType,
                "onUpdate:modelValue": ($event: any) => (relation.joinType = $event),
                options: _ctx.QBEJoinDefinitionDialogDescriptor.joinTypes
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]),
              _withDirectives(_createVNode("label", _hoisted_5, [
                _createTextVNode(_toDisplayString(relation.attributes.sourceEntity + ' --- ' + relation.attributes.entity), 1)
              ], 512), [
                [
                  _directive_tooltip,
                  relation.attributes.sourceEntity + ' --- ' + relation.attributes.entity,
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode("div", _hoisted_6, [
                _withDirectives(_createVNode("i", {
                  class: "fa fa-arrow-up kn-cursor-pointer",
                  onClick: ($event: any) => (_ctx.moveUp(index))
                }, null, 8, ["onClick"]), [
                  [_vShow, index !== 0 && _ctx.searchWord.trim() === '']
                ]),
                _withDirectives(_createVNode("i", {
                  class: "fa fa-arrow-down kn-cursor-pointer p-ml-2",
                  onClick: ($event: any) => (_ctx.moveDown(index))
                }, null, 8, ["onClick"]), [
                  [_vShow, index !== _ctx.filteredRelations.length - 1 && _ctx.searchWord.trim() === '']
                ]),
                _createVNode(_component_Checkbox, {
                  class: "p-ml-3",
                  modelValue: relation.isConsidered,
                  "onUpdate:modelValue": ($event: any) => (relation.isConsidered = $event),
                  binary: true
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}